import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-017f9ce2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "layout" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "layout-logo" }, null, -1))
const _hoisted_3 = { class: "layout-nav" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Nodes ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Etcd ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" TODO ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Item 4 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_MenuItem = _resolveComponent("MenuItem")!
  const _component_Menu = _resolveComponent("Menu")!
  const _component_Header = _resolveComponent("Header")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Content = _resolveComponent("Content")!
  const _component_Layout = _resolveComponent("Layout")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Layout, null, {
      default: _withCtx(() => [
        _createVNode(_component_Header, null, {
          default: _withCtx(() => [
            _createVNode(_component_Menu, {
              mode: "horizontal",
              theme: "dark",
              "active-name": _ctx.routeName
            }, {
              default: _withCtx(() => [
                _hoisted_2,
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_MenuItem, {
                    name: "node-list",
                    to: "/node-list"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Icon, { type: "ios-navigate" }),
                      _hoisted_4
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_MenuItem, {
                    name: "etcd",
                    to: "/etcd"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Icon, { type: "ios-keypad" }),
                      _hoisted_5
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_MenuItem, { name: "3" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Icon, { type: "ios-analytics" }),
                      _hoisted_6
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_MenuItem, { name: "4" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Icon, { type: "ios-paper" }),
                      _hoisted_7
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }, 8, ["active-name"])
          ]),
          _: 1
        }),
        _createVNode(_component_Content, { style: {padding: '0 50px', margin: '20px'} }, {
          default: _withCtx(() => [
            _createVNode(_component_router_view)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}